export default "/images/988eb087ba04024894b4d1ca74d4bf19.avif";